module.exports = __webpack_public_path__ + "static/media/google-play-badge.1a4a20c5.png";